import { useProfileAnalysisFilters } from '../../../hooks/useProfileAnalysisFilters'
import { useRiskProfileQueryParams } from '../../../hooks/useRiskProfileQueryParams'
import { RiskByAreaWidget } from '../widgets/RiskByAreaWidget'
import { TypeChartsSection } from './TypeChartsSection'
import { TypeMetricControl } from './TypeMetricControl'
import { TypeResultsSection } from './TypeResultsSection'
import { TypeStatsSection } from './TypeStatsSection'

export function TypeAnalysis() {
  const {
    metricOption,
    areaGroup,
    areas,
    selectedHazardGroups,
    selectedElementGroups,
    selectedWorkspace,
    selectedAreaTypesLabel,
    setMetricOption,
    damageStates,
  } = useProfileAnalysisFilters()

  const queryParams = useRiskProfileQueryParams({
    metric: metricOption.metric,
    selectedWorkspace,
    areaGroup,
    areas,
    selectedHazardGroups,
    selectedElementGroups,
    damageStates,
  })

  return (
    <div className="space-y-5">
      <TypeStatsSection queryParams={queryParams} metricOption={metricOption} />
      <TypeMetricControl metricOption={metricOption} onMetricChange={setMetricOption} />
      <TypeChartsSection
        queryParams={queryParams}
        metricOption={metricOption}
        showSingleElementCharts={selectedElementGroups.length === 1}
      />
      {areaGroup !== '' && (
        <RiskByAreaWidget
          queryParams={queryParams}
          metricOption={metricOption}
          areas={areas}
          selectedAreaTypesLabel={selectedAreaTypesLabel}
        />
      )}
      <TypeResultsSection queryParams={queryParams} />
    </div>
  )
}
